import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

const app = createApp(App)

axios.defaults.baseURL = 'https://phplaravel-1247916-4470616.cloudwaysapps.com/'
// axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json'

app.use(store).use(router).mount('#app')
